import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Heart, Activity, Sparkles, Syringe, Leaf, Scale, ArrowRight } from "lucide-react";
const services = [{
  title: "Residenza e Cittadinanza",
  description: "Percorsi dedicati per residenza e cittadinanza italiana, con assistenza professionale nella gestione di procedure amministrative e consolari.",
  icon: Heart,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/residenza_cittadinanza.png",
  link: "/ContactsPage"
}, {
  title: "Residenza Elettiva",
  description: "Supporto completo per l'ottenimento del visto per residenza elettiva, ideale per chi desidera stabilirsi in Italia senza lavorare.",
  icon: Activity,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/residenza_elettiva.png",
  link: "/ContactsPage"
}, {
  title: "Ricongiungimento Familiare",
  description: "Assistenza legale e burocratica per riunire i nuclei familiari in Italia, garantendo il rispetto di tutti i requisiti normativi.",
  icon: Sparkles,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/ricongiungimento_familiare.png",
  link: "/ContactsPage"
}, {
  title: "Permessi di Soggiorno",
  description: "Gestione pratiche per permessi di soggiorno per motivi di affari, lavoro o studio, con monitoraggio costante dell'iter burocratico.",
  icon: Syringe,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/permesso_soggiorno.png",
  link: "/ContactsPage"
}, {
  title: "Assistenza Consolare",
  description: "Servizi di consulenza e intermediazione documentale presso consolati ed ambasciate per la legalizzazione di atti internazionali.",
  icon: Leaf,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/assistenza_consolare.png",
  link: "/ExtrajudicialPage"
}, {
  title: "Istanze Enti Pubblici",
  description: "Supporto tecnico per la gestione di istanze in elaborazione presso enti pubblici, accelerando i tempi di risposta istituzionale.",
  icon: Scale,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/istanze_pubbliche.png",
  link: "/ContactsPage"
}];
export default function ServicesOverview() {
  return <section data-section-id="256145" id="services-grid" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="font-default text-3xl font-bold tracking-tight text-primary sm:text-4xl md:text-5xl">
            Servizi per l'Immigrazione
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-muted-foreground font-default">
            Consulenza professionale e assistenza dedicata per navigare con successo le procedure burocratiche e legali in Italia.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => <Card key={i} data-index={i} className="group relative h-[380px] overflow-hidden rounded-md border-0 shadow-md">
              <img src={service.image} data-wvc-srcset={`${service.image}-wvc-srcset`} data-wvc-sizes={`${service.image}-wvc-sizes`} alt={service.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110" loading="lazy" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-primary/95 via-primary/50 to-transparent transition-opacity duration-500 group-hover:from-primary/100 group-hover:via-primary/70" />

              {}
              <div className="absolute inset-0 flex flex-col justify-end p-6 text-primary-foreground">
                <div className="mb-4 inline-flex w-fit rounded-md bg-secondary/20 p-3 backdrop-blur-md transition-transform duration-500 group-hover:-translate-y-2">
                  <service.icon className="size-6 text-secondary" />
                </div>
                
                <h3 className="font-default text-2xl font-semibold tracking-tight transition-transform duration-500 group-hover:-translate-y-2">
                  {service.title}
                </h3>
                
                {}
                <div className="grid grid-rows-[0fr] transition-[grid-template-rows] duration-500 ease-in-out group-hover:grid-rows-[1fr]">
                  <div className="overflow-hidden">
                    <p className="mb-6 pt-3 text-sm leading-relaxed text-primary-foreground/80 opacity-0 transition-opacity duration-500 delay-100 group-hover:opacity-100 font-default">
                      {service.description}
                    </p>
                    <div className="opacity-0 transition-opacity duration-500 delay-200 group-hover:opacity-100">
                      <Link to={service.link}>
                        <Button variant="outline" className="border-secondary/50 bg-[#FFC829] text-primary backdrop-blur-sm hover:bg-[#FFC829]/90">
                          Scopri di più
                          <ArrowRight className="ml-2 size-4" />
                        </Button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}